import { useClientStore } from '@/client/stores/client';

/**
 * The bytes of a file a customer sent to a Meta number. Meta's own link needs
 * our access token, so the server fetches it; `request()` reads bodies as text,
 * which would corrupt the file, so this asks for a Blob and the proxy streams it.
 */
export async function fetchWhatsAppMediaBlob(mediaId: string): Promise<Blob> {
  const res = await fetch(`/api/admin/whatsapp/media/${encodeURIComponent(mediaId)}/download`, {
    method: 'GET',
    credentials: 'include',
    cache: 'no-store',
    headers: (useClientStore.getState().defaultHeaders ?? {}) as Record<string, string>,
  });
  if (!res.ok) {
    throw new Error(
      res.status === 404
        ? 'This file is no longer available from WhatsApp.'
        : `Could not load the file (${res.status}).`,
    );
  }
  return res.blob();
}
